export const AUVIOUS_VALID_URL_REGEX = /^https:\/\/(.*\.auvious.com|localhost|(.*auvious.video))(:\d+)?\/t\/.*$/i;
export const WIDGET_COBROWSE_REQUEST_PREFIX = "auvious:cobrowse-request:";
export const WIDGET_REFERRER_ID = "auvious.origin.widget.videoCall";
export const WIDGET_CONVERSATION_TYPE = "auvious.origin.widget.conversation.type";
export const WIDGET_MODE = "auvious.origin.widget.mode";
export const WIDGET_CONTACT = "auvious.origin.widget.contact";
export const WIDGET_MESSAGE_UUID = "auvious.origin.widget.message.uuid";
export const KEY_SESSION_TOKEN = "auvious.session.token";
export const KEY_SESSION_ID = "auvious.session.id";
export const KEY_WEB_MESSAGING = "auvious.web.messaging";
export const KEY_CX_DFO = "auvious.cxone.dfo.";
export const KEY_VERINT_LIVE = "auvious.verint.live";
export const KEY_VERINT_LOG_MSG = "auvious.verint.log.messages";
export const KEY_VERINT_LOG_ATTACH = "auvious.verint.log.attachments";
export const KEY_VERINT_LOG_MEMBERS = "auvious.verint.log.members";
export const KEY_SESSION_CODE = "auvious.session.code";
// export const KEY_WEB_MESSAGING = "auvious.web.messaging";
// export const KEY_DIGITAL_CONNECT = "auvious.digital.connect";
export const DEFAULT_AGENT_ID = "AGENT";
export const DEFAULT_CUSTOMER_ID = "CUSTOMER";
export var OriginModeEnum;
(function (OriginModeEnum) {
    OriginModeEnum["kiosk"] = "kiosk";
    OriginModeEnum["website"] = "website";
})(OriginModeEnum || (OriginModeEnum = {}));
export const WIDGET_SOURCE_MAP = {
    "mypurecloud.com": "https://apps.mypurecloud.com/widgets",
    "usw2.pure.cloud": "https://apps.usw2.pure.cloud/widgets",
    "cac1.pure.cloud": "https://apps.cac1.pure.cloud/widgets",
    "mypurecloud.com.au": "https://apps.mypurecloud.com.au/widgets",
    "mypurecloud.ie": "https://apps.mypurecloud.ie/widgets",
    "mypurecloud.de": "https://apps.mypurecloud.de/widgets",
    "euw2.pure.cloud": "https://apps.euw2.pure.cloud/widgets",
    "mypurecloud.jp": "https://apps.mypurecloud.jp/widgets",
    "apne2.pure.cloud": "https://apps.apne2.pure.cloud/widgets",
    "use2.us-gov-pure.cloud": "https://apps.use2.us-gov-pure.cloud/widgets",
    "aps1.pure.cloud": "https://apps.aps1.pure.cloud/widgets",
    "sae1.pure.cloud": "https://apps.sae1.pure.cloud/widgets",
};
export const API_SOURCE_MAP = {
    "mypurecloud.com": "https://api.mypurecloud.com",
    "usw2.pure.cloud": "https://api.usw2.pure.cloud",
    "cac1.pure.cloud": "https://api.cac1.pure.cloud",
    "mypurecloud.com.au": "https://api.mypurecloud.com.au",
    "mypurecloud.ie": "https://api.mypurecloud.ie",
    "mypurecloud.de": "https://api.mypurecloud.de",
    "euw2.pure.cloud": "https://api.euw2.pure.cloud",
    "mypurecloud.jp": "https://api.mypurecloud.jp",
    "apne2.pure.cloud": "https://api.apne2.pure.cloud",
    "use2.us-gov-pure.cloud": "https://api.use2.us-gov-pure.cloud",
    "aps1.pure.cloud": "https://api.aps1.pure.cloud",
    "sae1.pure.cloud": "https://api.sae1.pure.cloud",
};
export var ErrorCode;
(function (ErrorCode) {
    ErrorCode[ErrorCode["EVENT_CLIENT_ERROR"] = 1] = "EVENT_CLIENT_ERROR";
    ErrorCode[ErrorCode["DEVICE_DETECT_FAILED"] = 2] = "DEVICE_DETECT_FAILED";
    ErrorCode[ErrorCode["COPY_TO_CLIPBOARD_FAILED"] = 3] = "COPY_TO_CLIPBOARD_FAILED";
    ErrorCode[ErrorCode["ERROR_LOG_FAILED"] = 4] = "ERROR_LOG_FAILED";
    ErrorCode[ErrorCode["MEDIA_PLAYER_HTML_PARSE_FAILED"] = 5] = "MEDIA_PLAYER_HTML_PARSE_FAILED";
    ErrorCode[ErrorCode["GENESYS_API_ERROR"] = 6] = "GENESYS_API_ERROR";
    ErrorCode[ErrorCode["DIGITAL_CONNECT_API_ERROR"] = 7] = "DIGITAL_CONNECT_API_ERROR";
    ErrorCode[ErrorCode["AUTHENTICATION_ERROR"] = 8] = "AUTHENTICATION_ERROR";
    ErrorCode[ErrorCode["RTC_REGISTRATION_ERROR"] = 9] = "RTC_REGISTRATION_ERROR";
    ErrorCode[ErrorCode["INIT_CHAT_SERVICE_FAILED"] = 10] = "INIT_CHAT_SERVICE_FAILED";
    ErrorCode[ErrorCode["INIT_MISSING_REQUIRED_PROPERTY"] = 11] = "INIT_MISSING_REQUIRED_PROPERTY";
    ErrorCode[ErrorCode["INIT_INVALID_PC_ENVIRONMENT"] = 12] = "INIT_INVALID_PC_ENVIRONMENT";
    ErrorCode[ErrorCode["INIT_INVALID_REGISTRATION_TYPE"] = 13] = "INIT_INVALID_REGISTRATION_TYPE";
    ErrorCode[ErrorCode["INIT_INVALID_GREETING_ACTION"] = 14] = "INIT_INVALID_GREETING_ACTION";
    ErrorCode[ErrorCode["COBROWSE_INVALID_PIN"] = 20] = "COBROWSE_INVALID_PIN";
    ErrorCode[ErrorCode["COBROWSE_API_ERROR"] = 21] = "COBROWSE_API_ERROR";
    ErrorCode[ErrorCode["COBROWSE_TERMINATE_FAILED"] = 21] = "COBROWSE_TERMINATE_FAILED";
    ErrorCode[ErrorCode["COBROWSE_AUTHENTICATE_FAILED"] = 22] = "COBROWSE_AUTHENTICATE_FAILED";
    ErrorCode[ErrorCode["COBROWSE_LEAVE_FAILED"] = 23] = "COBROWSE_LEAVE_FAILED";
    ErrorCode[ErrorCode["COBROWSE_JOIN_FAILED"] = 24] = "COBROWSE_JOIN_FAILED";
    ErrorCode[ErrorCode["COBROWSE_RESUME_FAILED"] = 25] = "COBROWSE_RESUME_FAILED";
    ErrorCode[ErrorCode["COBROWSE_DISPLAY_CAPTURE_FAILED"] = 26] = "COBROWSE_DISPLAY_CAPTURE_FAILED";
    ErrorCode[ErrorCode["COBROWSE_DISPLAY_CAPTURE_PUBLISH_FAILED"] = 27] = "COBROWSE_DISPLAY_CAPTURE_PUBLISH_FAILED";
    ErrorCode[ErrorCode["FILE_TRANSFER_API_ERROR"] = 30] = "FILE_TRANSFER_API_ERROR";
    ErrorCode[ErrorCode["REGISTRATION_INVALID_CUSTOM_FIELDS"] = 40] = "REGISTRATION_INVALID_CUSTOM_FIELDS";
    ErrorCode[ErrorCode["REGISTRATION_MISSING_CUSTOM_FIELDS"] = 41] = "REGISTRATION_MISSING_CUSTOM_FIELDS";
    ErrorCode[ErrorCode["REGISTRATION_REQUIRED_FIELD"] = 42] = "REGISTRATION_REQUIRED_FIELD";
    ErrorCode[ErrorCode["REGISTRATION_INVALID_CUSTOMER_METADATA_FORMAT"] = 43] = "REGISTRATION_INVALID_CUSTOMER_METADATA_FORMAT";
    ErrorCode[ErrorCode["REGISTRATION_CAPTCHA_FAILED"] = 44] = "REGISTRATION_CAPTCHA_FAILED";
    ErrorCode[ErrorCode["CONVERSATION_START_FAILED"] = 50] = "CONVERSATION_START_FAILED";
    ErrorCode[ErrorCode["CONVERSATION_END_FAILED"] = 51] = "CONVERSATION_END_FAILED";
    ErrorCode[ErrorCode["CONVERSATION_URL_PARSE_FAILED"] = 52] = "CONVERSATION_URL_PARSE_FAILED";
    ErrorCode[ErrorCode["CONVERSATION_URL_MISSING"] = 53] = "CONVERSATION_URL_MISSING";
    ErrorCode[ErrorCode["CONVERSATION_JOIN_FAILED"] = 54] = "CONVERSATION_JOIN_FAILED";
    ErrorCode[ErrorCode["CONVERSATION_INVALID_METADATA"] = 55] = "CONVERSATION_INVALID_METADATA";
    ErrorCode[ErrorCode["CONVERSATION_MESSAGE_PARSE_FAILED"] = 56] = "CONVERSATION_MESSAGE_PARSE_FAILED";
    ErrorCode[ErrorCode["CONVERSATION_CUSTOMER_CONNECT_FAILED"] = 57] = "CONVERSATION_CUSTOMER_CONNECT_FAILED";
    ErrorCode[ErrorCode["CONVERSATION_TYPING_INDICATOR_FAILED"] = 58] = "CONVERSATION_TYPING_INDICATOR_FAILED";
    ErrorCode[ErrorCode["CONVERSATION_MESSAGE_SEND_FAILED"] = 59] = "CONVERSATION_MESSAGE_SEND_FAILED";
    ErrorCode[ErrorCode["MEDIA_DEVICES_NOT_AVAILABLE"] = 60] = "MEDIA_DEVICES_NOT_AVAILABLE";
    ErrorCode[ErrorCode["MEDIA_DEVICES_GET_USER_MEDIA_FAILED"] = 61] = "MEDIA_DEVICES_GET_USER_MEDIA_FAILED";
    ErrorCode[ErrorCode["BROWSER_NOT_SUPPORTED"] = 62] = "BROWSER_NOT_SUPPORTED";
    ErrorCode[ErrorCode["SKETCH_START_FAILED"] = 70] = "SKETCH_START_FAILED";
    ErrorCode[ErrorCode["SKETCH_API_ERROR"] = 71] = "SKETCH_API_ERROR";
    ErrorCode[ErrorCode["SECURITY_OTP_REQUEST_FAILED"] = 80] = "SECURITY_OTP_REQUEST_FAILED";
    ErrorCode[ErrorCode["SECURITY_CALLBACK_CREATE_FAILED"] = 81] = "SECURITY_CALLBACK_CREATE_FAILED";
    ErrorCode[ErrorCode["LOCALE_COUNTRY_CODES_FAILED"] = 90] = "LOCALE_COUNTRY_CODES_FAILED";
    ErrorCode[ErrorCode["LOCALE_TRANSLATION_LOAD_FAILED"] = 91] = "LOCALE_TRANSLATION_LOAD_FAILED";
    ErrorCode[ErrorCode["WEB_MESSAGING_BAD_REQUEST"] = 400] = "WEB_MESSAGING_BAD_REQUEST";
    ErrorCode[ErrorCode["WEB_MESSAGING_AUTHENTICATION_FAILED"] = 401] = "WEB_MESSAGING_AUTHENTICATION_FAILED";
    ErrorCode[ErrorCode["WEB_MESSAGING_FORBIDDEN"] = 403] = "WEB_MESSAGING_FORBIDDEN";
    ErrorCode[ErrorCode["WEB_MESSAGING_NOT_FOUND"] = 404] = "WEB_MESSAGING_NOT_FOUND";
    ErrorCode[ErrorCode["WEB_MESSAGING_REQUEST_TIMEOUT"] = 408] = "WEB_MESSAGING_REQUEST_TIMEOUT";
    ErrorCode[ErrorCode["WEB_MESSAGING_SESSION_READ_ONLY"] = 409] = "WEB_MESSAGING_SESSION_READ_ONLY";
    ErrorCode[ErrorCode["WEB_MESSAGING_TOO_MANY_REQUESTS_RETRY_LATER"] = 429] = "WEB_MESSAGING_TOO_MANY_REQUESTS_RETRY_LATER";
    ErrorCode[ErrorCode["WEB_MESSAGING_FILE_TYPE_NOT_SUPPORTED"] = 4001] = "WEB_MESSAGING_FILE_TYPE_NOT_SUPPORTED";
    ErrorCode[ErrorCode["WEB_MESSAGING_FILE_SIZE_TOO_BIG"] = 4002] = "WEB_MESSAGING_FILE_SIZE_TOO_BIG";
    ErrorCode[ErrorCode["WEB_MESSAGING_FILE_CONTENT_INVALID"] = 4003] = "WEB_MESSAGING_FILE_CONTENT_INVALID";
    ErrorCode[ErrorCode["WEB_MESSAGING_FILE_NAME_INVALID"] = 4004] = "WEB_MESSAGING_FILE_NAME_INVALID";
    ErrorCode[ErrorCode["WEB_MESSAGING_FILE_NAME_TOO_LONG"] = 4005] = "WEB_MESSAGING_FILE_NAME_TOO_LONG";
    ErrorCode[ErrorCode["WEB_MESSAGING_SESSION_EXPIRED"] = 4006] = "WEB_MESSAGING_SESSION_EXPIRED";
    ErrorCode[ErrorCode["WEB_MESSAGING_SESSION_NOT_FOUND"] = 4007] = "WEB_MESSAGING_SESSION_NOT_FOUND";
    ErrorCode[ErrorCode["WEB_MESSAGING_ATTACHMENT_EXPIRED"] = 4008] = "WEB_MESSAGING_ATTACHMENT_EXPIRED";
    ErrorCode[ErrorCode["WEB_MESSAGING_ATTACHMENT_NOT_FOUND"] = 4009] = "WEB_MESSAGING_ATTACHMENT_NOT_FOUND";
    ErrorCode[ErrorCode["WEB_MESSAGING_ATTACHMENT_UPLOAD_FAILED"] = 4010] = "WEB_MESSAGING_ATTACHMENT_UPLOAD_FAILED";
    ErrorCode[ErrorCode["WEB_MESSAGING_MESSAGE_LENGTH_TOO_LONG"] = 4011] = "WEB_MESSAGING_MESSAGE_LENGTH_TOO_LONG";
    ErrorCode[ErrorCode["WEB_MESSAGING_SESSION_CLOSED"] = 4012] = "WEB_MESSAGING_SESSION_CLOSED";
    ErrorCode[ErrorCode["WEB_MESSAGING_CUSTOM_ATTRIBUTES_TOO_LARGE"] = 4013] = "WEB_MESSAGING_CUSTOM_ATTRIBUTES_TOO_LARGE";
    ErrorCode[ErrorCode["WEB_MESSAGING_TOO_MANY_REQUESTS"] = 4029] = "WEB_MESSAGING_TOO_MANY_REQUESTS";
    ErrorCode[ErrorCode["WEB_MESSAGING_ATTACHMENT_EMPTY"] = 4102] = "WEB_MESSAGING_ATTACHMENT_EMPTY";
})(ErrorCode || (ErrorCode = {}));
export var ConversationTypeEnum;
(function (ConversationTypeEnum) {
    ConversationTypeEnum["videoCall"] = "video";
    ConversationTypeEnum["voiceCall"] = "audio";
    ConversationTypeEnum["callback"] = "callback";
    ConversationTypeEnum["cobrowse"] = "cobrowse";
    ConversationTypeEnum["close"] = "close";
    ConversationTypeEnum["chat"] = "chat";
})(ConversationTypeEnum || (ConversationTypeEnum = {}));
